export default __webpack_public_path__ + "static/media/icon-multimedia.a5747f71.svg";